import { getDisplayLocale } from './formatSafety';

export const RECEIPT_LABELS = {
  fr: {
    clientReceiptTitle: 'Reçu Client',
    clientReceiptBanner: 'REÇU CLIENT',
    merchantReceiptTitle: 'Reçu du Commerçant',
    merchantReceiptBanner: 'REÇU DU COMMERÇANT',
    receiptTitleClient: 'REÇU CLIENT',
    receiptTitleMerchant: 'REÇU COMMERÇANT',
    receiptTitleAddition: 'ADDITION',
    seller: 'Vendeur:',
    customer: 'Client:',
    customerPhone: 'Tél. Client:',
    location: 'Localisation:',
    product: 'Produit',
    qty: 'Qté',
    price: 'Prix',
    total: 'Total',
    subtotal: 'Sous-total:',
    discount: 'Remise:',
    afterDiscount: 'Après remise:',
    tax: 'Taxe:',
    totalLabel: 'Total:',
    payment: 'Paiement:',
    paymentType: 'Type:',
    cash: 'Espèces',
    electronic: 'Électronique',
    paymentPending: 'Non payé',
    cashPaid: 'Montant payé:',
    change: 'Monnaie:',
    notes: 'Notes:',
    orderNo: 'N° Commande:',
    dateTime: 'Date et Heure:',
    thankYou: 'Merci pour votre achat!',
    footerDefault: 'Merci pour votre achat!',
    footerAddition: 'À régler en caisse — non payé',
    optionalClient: 'Client (optionnel)',
    clientPlaceholder: 'Nom du client ou numéro de téléphone',
    addNewCustomer: (name) => `+ Ajouter "${name}" comme nouveau client`,
    print: 'Imprimer',
    printing: 'Impression...',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    confirmPrintTitle: 'Confirmer l\'impression',
    confirmPrintMessage: (count, total) =>
      `Êtes-vous sûr de vouloir imprimer le reçu ? ${count} produits du panier (${total}) seront imprimés.`,
    printSuccessTitle: 'Impression réussie',
    printSuccessMessage: 'Le reçu a été envoyé à l\'imprimante',
    printError: 'Erreur lors de l\'impression du reçu',
    noPrintDataTitle: 'Aucune donnée à imprimer',
    noPrintDataMessage: 'Veuillez vous assurer que la vente contient des produits',
    defaultSeller: 'Vendeur',
    defaultArticle: 'Article',
    paymentCash: 'Espèces',
    paymentElectronic: 'Électronique',
    thermalCashPaid: 'Montant payé',
    thermalChange: 'Monnaie',
    article: 'Article',
    receiptNo: 'N° reçu',
    date: 'Date',
    time: 'Heure',
    cashier: 'Caissier',
    items: 'Articles',
    vat: 'TVA',
    totalThermal: 'TOTAL',
    nif: 'NIF',
    htmlTitleClient: 'Reçu Client',
    htmlTitleMerchant: 'Reçu Commerçant'
  },
  ar: {
    clientReceiptTitle: 'إيصال العميل',
    clientReceiptBanner: 'إيصال العميل',
    merchantReceiptTitle: 'إيصال التاجر',
    merchantReceiptBanner: 'إيصال التاجر',
    receiptTitleClient: 'إيصال العميل',
    receiptTitleMerchant: 'إيصال التاجر',
    receiptTitleAddition: 'الفاتورة',
    seller: 'البائع:',
    customer: 'العميل:',
    customerPhone: 'هاتف العميل:',
    location: 'الموقع:',
    product: 'المنتج',
    qty: 'الكمية',
    price: 'السعر',
    total: 'الإجمالي',
    subtotal: 'الإجمالي الفرعي:',
    discount: 'الخصم:',
    afterDiscount: 'بعد الخصم:',
    tax: 'الضريبة:',
    totalLabel: 'الإجمالي:',
    payment: 'طريقة الدفع:',
    paymentType: 'نوع الدفع:',
    cash: 'نقداً',
    electronic: 'إلكتروني',
    paymentPending: 'غير مدفوع',
    cashPaid: 'المبلغ المدفوع:',
    change: 'الباقي:',
    notes: 'ملاحظات:',
    orderNo: 'رقم الطلب:',
    dateTime: 'التاريخ والوقت:',
    thankYou: 'شكراً على شرائكم!',
    footerDefault: 'شكراً على شرائكم!',
    footerAddition: 'للدفع عند الصندوق — غير مدفوع',
    optionalClient: 'العميل (اختياري)',
    clientPlaceholder: 'اسم العميل أو رقم الهاتف',
    addNewCustomer: (name) => `+ إضافة "${name}" كعميل جديد`,
    print: 'طباعة',
    printing: 'جاري الطباعة...',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    confirmPrintTitle: 'تأكيد الطباعة',
    confirmPrintMessage: (count, total) =>
      `هل أنت متأكد من طباعة الإيصال؟ سيتم طباعة ${count} منتج من السلة بقيمة ${total}.`,
    printSuccessTitle: 'تم الطباعة بنجاح',
    printSuccessMessage: 'تم إرسال الإيصال إلى الطابعة',
    printError: 'خطأ في طباعة الإيصال',
    noPrintDataTitle: 'لا توجد بيانات للطباعة',
    noPrintDataMessage: 'يرجى التأكد من وجود منتجات في البيع',
    defaultSeller: 'بائع',
    defaultArticle: 'منتج',
    paymentCash: 'نقداً',
    paymentElectronic: 'إلكتروني',
    thermalCashPaid: 'المبلغ المدفوع',
    thermalChange: 'الباقي',
    article: 'المنتج',
    thermalColQty: 'كم',
    thermalColPrice: 'سعر',
    thermalColTotal: 'المجموع',
    receiptNo: 'رقم الإيصال',
    date: 'التاريخ',
    time: 'الوقت',
    cashier: 'أمين الصندوق',
    items: 'المنتجات',
    vat: 'الضريبة',
    totalThermal: 'الإجمالي',
    nif: 'الرقم الضريبي',
    htmlTitleClient: 'إيصال العميل',
    htmlTitleMerchant: 'إيصال التاجر'
  }
};

export function normalizeReceiptLanguage(language) {
  return language === 'ar' ? 'ar' : 'fr';
}

export function getReceiptLocale(language = 'fr') {
  return getDisplayLocale(normalizeReceiptLanguage(language) === 'ar');
}

export function isReceiptRtl(language = 'fr') {
  return normalizeReceiptLanguage(language) === 'ar';
}

export function getReceiptLabel(key, language = 'fr') {
  const lang = normalizeReceiptLanguage(language);
  const value = RECEIPT_LABELS[lang]?.[key] ?? RECEIPT_LABELS.fr[key];
  if (typeof value === 'function') {
    return value;
  }
  return value ?? key;
}

export function getReceiptPrintOptions(currentLanguage, type = 'client') {
  const language = normalizeReceiptLanguage(currentLanguage);
  return {
    type,
    language,
    locale: getReceiptLocale(language)
  };
}
